<py-modal
  [title]="'cart.emptyCart_title' | cxTranslate"
  [actions]="templateActions"
  [showCancelButton]="true"
  [scrollable]="true"
  [size]="'sm'"
  [centered]="true"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
>
  <p>{{ 'cart.emptyCartConfirmation_text' | cxTranslate }}</p>
</py-modal>

<ng-template #templateActions>
  <button class="btn btn-danger" (click)="onRemove()">
    {{ 'cart.emptyCart_action' | cxTranslate }}
  </button>
</ng-template>
